module.exports = __webpack_public_path__ + "0f8ffe7d2748c670fa1a5fe74fc0f4d7.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/plans/keurig_dr_pepper.png
// module id = 2037
// module chunks = 0